import { baseURL } from "../utils/constants";
import axiosInstance from "../utils/axiosUtil";

export interface TVConfiguration {
  tv_config_id: string;
  hospital_id: string;
  token: boolean;
  patient_name: boolean;
  room_number: boolean;
  slot: boolean;
  created_at: string;
  updated_at: string;
  hospital_name: string;
  booking_mode: boolean;
}

export interface UpdateTVConfiguration {
  token?: boolean;
  patient_name?: boolean;
  room_number?: boolean;
  slot?: boolean;
  booking_mode?: boolean;
}

// GET TV Configuration by hospital ID
export const getTVConfiguration = async (hospitalId: string) => {
  try {
    const res = await axiosInstance.get(`${baseURL}/tv-configuration/${hospitalId}`);
    return res;
  } catch (error: any) {
    if (error.response || error.response.status === 403) {
      return error.response;
    } else {
      console.error(error);
    }
  }
};

// Update TV Configuration
export const updateTVConfiguration = async (
  hospitalId: string,
  updates: UpdateTVConfiguration
) => {
  try {
    const res = await axiosInstance.put(`${baseURL}/tv-configuration/${hospitalId}`, updates);
    return res;
  } catch (error: any) {
    if (error.response || error.response.status === 403) {
      return error.response;
    } else {
      console.error(error);
    }
  }
};

// Delete TV Configuration
export const deleteTVConfiguration = async (hospitalId: string) => {
  try {
    const res = await axiosInstance.delete(`${baseURL}/tv-configuration/${hospitalId}`);
    return res;
  } catch (error: any) {
    if (error.response || error.response.status === 403) {
      return error.response;
    } else {
      console.error(error);
    }
  }
};

